import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import { XSMALL_BREAKPOINT } from '../../style'

export const Container = styled.div`
  background: ${colors.gandalf};
  border-radius: 0.75rem;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div:last-of-type {
    padding: 0.375rem 0;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    flex-direction: column;
    padding: 0;
  }
`
export const Thumbnail = styled.div<{ thumb?: string }>`
  width: 7.25rem;
  height: 5rem;
  background: ${({ thumb }) => thumb && `url(${thumb}) no-repeat center`} ${colors.dust};
  background-size: cover;
  border-radius: 0.5rem;
  margin-right: 1rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: none;
  }
`
export const Info = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    border-bottom: 1px solid ${colors.radagast};
    width: 100%;
    padding: 0.75rem;
  }

  span {
    margin-left: 0.5rem;
    cursor: pointer;

    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      display: none;
    }
  }

  .mobileChange {
    display: none;
    cursor: pointer;

    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      display: block;
    }
  }
`
export const Price = styled.div`
  white-space: nowrap;
  text-align: center;

  > span {
    font-size: 1rem;
    line-height: 1.75rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/PurchaseProduct/PurchaseProduct.style.tsx